// Calculs financiers purs, sans état : faciles à tester.

export function round2(value: number): number {
  return Math.round(value * 100) / 100;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/** Mensualité constante d'un crédit amortissable. */
export function loanMonthlyPayment(principal: number, annualRate: number, months: number): number {
  const monthlyRate = annualRate / 12;
  if (monthlyRate === 0) return principal / months;
  return (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months));
}

/** Valeur future d'une somme placée une fois, avec intérêts composés chaque année. */
export function futureValue(amount: number, annualRate: number, years: number): number {
  return amount * Math.pow(1 + annualRate, years);
}

/** Valeur future d'un versement mensuel constant, avec intérêts composés chaque mois. */
export function futureValueOfMonthly(monthly: number, annualRate: number, years: number): number {
  const monthlyRate = annualRate / 12;
  const months = years * 12;
  if (monthlyRate === 0) return monthly * months;
  return (monthly * (Math.pow(1 + monthlyRate, months) - 1)) / monthlyRate;
}
